import { render } from "./MngAlert.vue?vue&type=template&id=31e80094&ts=true"
import script from "./MngAlert.vue?vue&type=script&lang=ts"
export * from "./MngAlert.vue?vue&type=script&lang=ts"

import "./MngAlert.vue?vue&type=style&index=0&id=31e80094&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__